/* --------------------------------------------------------------------------------------
   xwToggleSwitch.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/* eslint semi: ["error", "never"]*/
export class xwToggleSwitch {
    /* @ngInject*/
    constructor(appSettings) {
        this.restrict = 'A'
        this.require = '?ngModel'
        this.appSettings = appSettings
        this.scope = {
            onSwitch: '&',
            ngModel: '='
        }
    }
    link(scope, elem, attrs, ngModel) {
        const options = {
            theme: attrs.theme? attrs.theme : this.appSettings.primaryColor,
            widgetSize: attrs.widgetSize,
            light: attrs.light,
            initialValue: scope.ngModel
        }

        elem.first().xrxtoggleswitch(options)

        elem.first().on('slidechange', (event, ui) => {
            ngModel.$setViewValue(!!+ui.value)
            scope.onSwitch()
            elem.first().find('.ui-slider-handle').removeClass("ui-state-focus")
        })

        scope.$watch('ngModel', (value) => {
            elem.first().xrxtoggleswitch('value', value)
        })  
    }
    static directiveFactory(appSettings) {
        xwToggleSwitch.instance = new xwToggleSwitch(appSettings)
        return xwToggleSwitch.instance
    }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwToggleSwitch.directive.js